import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Clock, Heart, Share2, Bookmark, Check } from 'lucide-react';
import { toast } from 'sonner';
import { PageHeader } from '../PageHeader';
import { useApp } from '../store';
export function ArticlePage() {
  const {
    id
  } = useParams();
  const {
    articles
  } = useApp();
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(24);
  const [bookmarked, setBookmarked] = useState(false);
  const article = articles.find(a => a.id === id);
  if (!article) {
    return <div className="text-center py-20" data-id="element-392">
        <p className="text-navy-500 mb-4" data-id="element-393">That article couldn't be found.</p>
        <Link to="/news" className="text-gold-600 font-semibold" data-id="element-394">
          Back to News
        </Link>
      </div>;
  }
  const related = articles.filter(a => a.id !== article.id).slice(0, 3);
  const handleLike = () => {
    setLiked(!liked);
    setLikeCount(liked ? likeCount - 1 : likeCount + 1);
  };
  const handleBookmark = () => {
    const next = !bookmarked;
    setBookmarked(next);
    if (next) {
      toast.success('Saved to your reading list');
    } else {
      toast('Removed from your reading list');
    }
  };
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: article.title,
          url: window.location.href
        });
      } catch (err) {
        // user cancelled or failed
      }
    } else {
      navigator.clipboard.writeText(window.location.href);
      toast.success('Link copied to clipboard');
    }
  };
  return <article className="max-w-3xl mx-auto" data-id="element-395">
      <PageHeader title="" backTo="/news" backLabel="Back to News" data-id="element-396" />

      <span className="text-xs font-bold uppercase tracking-widest text-gold-600" data-id="element-397">
        {article.category}
      </span>
      <h1 className="text-3xl sm:text-4xl font-serif font-bold text-navy-900 leading-tight mt-2 mb-4" data-id="element-398">
        {article.title}
      </h1>

      <div className="flex items-center gap-3 pb-5 mb-6 border-b border-navy-100" data-id="element-399">
        <img src={article.authorAvatar} alt="" className="w-11 h-11 rounded-full" data-id="element-400" />
        <div className="text-sm" data-id="element-401">
          <p className="font-bold text-navy-900" data-id="element-402">{article.author}</p>
          <p className="text-navy-400 flex items-center gap-1.5" data-id="element-403">
            {article.date} <span data-id="element-404">·</span> <Clock className="w-3 h-3" data-id="element-405" />{' '}
            {article.readTime}
          </p>
        </div>
        <div className="ml-auto flex items-center gap-1 relative" data-id="element-406">
          <button onClick={handleLike} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full transition-colors text-sm font-medium ${liked ? 'text-gold-600 bg-gold-50' : 'text-navy-500 hover:bg-navy-50'}`} aria-label={liked ? 'Unlike' : 'Like'} data-id="element-407">
            <Heart className="w-4 h-4" fill={liked ? 'currentColor' : 'none'} data-id="element-408" />
            <span data-id="element-409">{likeCount}</span>
          </button>
          <button onClick={handleBookmark} className={`p-2 rounded-full transition-colors ${bookmarked ? 'text-gold-600 bg-gold-50' : 'text-navy-500 hover:bg-navy-50'}`} aria-label={bookmarked ? 'Remove bookmark' : 'Bookmark'} data-id="element-410">
            <Bookmark className="w-5 h-5" fill={bookmarked ? 'currentColor' : 'none'} data-id="element-411" />
          </button>
          <button onClick={handleShare} className="p-2 text-navy-500 hover:bg-navy-50 rounded-full" aria-label="Share" data-id="element-412">
            <Share2 className="w-5 h-5" data-id="element-413" />
          </button>
        </div>
      </div>

      <img src={article.image} alt="" className="w-full h-72 object-cover rounded-2xl mb-8" data-id="element-414" />

      <div className="prose-lg space-y-5 text-navy-800 leading-relaxed text-lg" data-id="element-415">
        {article.body.map((p, i) => <p key={i} data-id="element-416">{p}</p>)}
      </div>

      <div className="mt-14 pt-8 border-t border-navy-100" data-id="element-417">
        <h2 className="text-xl font-serif font-bold text-navy-900 mb-4" data-id="element-418">
          More from News
        </h2>
        <div className="grid sm:grid-cols-3 gap-4" data-id="element-419">
          {related.map(a => <Link key={a.id} to={`/news/${a.id}`} className="block group bg-white rounded-xl border border-navy-100 overflow-hidden hover:shadow-md transition-shadow" data-id="element-420">
              <img src={a.image} alt="" className="w-full h-28 object-cover" data-id="element-421" />
              <div className="p-3" data-id="element-422">
                <h3 className="text-sm font-serif font-bold text-navy-900 leading-snug group-hover:text-gold-600 transition-colors" data-id="element-423">
                  {a.title}
                </h3>
              </div>
            </Link>)}
        </div>
      </div>
    </article>;
}